import { render, staticRenderFns } from "./KrampSettings.vue?vue&type=template&id=4130d780&scoped=true"
import script from "./KrampSettings.vue?vue&type=script&lang=ts"
export * from "./KrampSettings.vue?vue&type=script&lang=ts"
import style0 from "./KrampSettings.vue?vue&type=style&index=0&id=4130d780&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4130d780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4130d780')) {
      api.createRecord('4130d780', component.options)
    } else {
      api.reload('4130d780', component.options)
    }
    module.hot.accept("./KrampSettings.vue?vue&type=template&id=4130d780&scoped=true", function () {
      api.rerender('4130d780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/default/KrampSettings.vue"
export default component.exports